import requestNotificationPermission from './requestNotificationPermission';
import getSubscribeWebpush from 'Api/web-push/subsribeWebpush';

const subscribeUser = async () => {
  const hasPermission = await requestNotificationPermission();
  if (!hasPermission) return;
  const applicationServerKey = process.env.REACT_APP_WEB_PUSH_PUBLIC_KEY;
  const registration = await navigator.serviceWorker.ready;
  await registration.pushManager.getSubscription().then((subscribtion) => {
    if (subscribtion) subscribtion?.unsubscribe();
  });
  const subscribe = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey,
  }).catch(() => null);

  if (!subscribe) return;

  getSubscribeWebpush(subscribe);
  return subscribe;
};

export default subscribeUser;
